export const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && (
                <div style={{ padding: '9px' }}>
                    {children}
                </div>
            )}
        </div>
    );
};